/**
 * LayerTreeManager
 */
import EventEmitter from "wolfy87-eventemitter";
import LayerTreeStateProxy from "./LayerTreeStateProxy";
import LayerTree from "./LayerTree";
class LayerTreeManager extends EventEmitter{
    stateProxy = null;
    constructor(state){ 
        super(state);
        this.stateProxy = new LayerTreeStateProxy(state);
    }
    _onCheckLayer = (item)=>{
        this.stateProxy.addLayers(item);
    }

    getUI = ()=>{
        return <LayerTree stateProxy={this.stateProxy} onCheckLayer={this._onCheckLayer}></LayerTree>
    }
}
export default LayerTreeManager;